export const isDigitsOnly = (value: string | undefined): boolean => {
  if (value === undefined || value === '') {
    return true;
  }
  if (typeof value !== 'undefined') {
    return /^\d+$/.test(value);
  }
  return false;
};

export const isBelowLength =
  (length: number) =>
  (value: string | undefined): boolean => {
    if (typeof value !== 'undefined') {
      return value.length <= length;
    }
    return false;
  };
